import { FC } from "react";
import { LeaderBoardScreenHeader } from "screens/components/LeaderBoardScreenHeader.tsx/LeaderBoardScreenHeader";
import { Timer } from "screens/components/Timer/Timer";
import { LeaderboardTabs } from "../components/LeaderBoardTabs/LeaderBoardTabs";
import "./LeaderBoardScreen.scss";

export const LeaderBoardScreen: FC = (props) => {
  return (
    <div className="container">
      <LeaderBoardScreenHeader />
      <LeaderboardTabs />
      <Timer />
    </div>
  );
};
